import { render } from "./ConstructorLayout.vue?vue&type=template&id=0bcb461e"
import script from "./ConstructorLayout.vue?vue&type=script&lang=js"
export * from "./ConstructorLayout.vue?vue&type=script&lang=js"

import "./ConstructorLayout.vue?vue&type=style&index=0&id=0bcb461e&lang=css"

import exportComponent from "/vhost/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__